<template>
  <div class="news-article">
    <div v-if="n">
      <img class="w-100" :src="n.articleImg" />
        <div class="container py-5">
          <h3 class="text-start">
            <span class="px-2 mx-2 text-primary rounded">NEWS</span>
          </h3>
          <p class="float-end">{{ n.time }}</p>
          <div class="bg-white text-start my-5">
            <component :is="comp"></component>
          </div>
      </div>
    </div>
  </div>
  <!-- 聯絡我們 -->
  <ContactFooter />
</template>
<script>
import news from "@/config/news.js";
import { defineAsyncComponent } from "vue";
import ContactFooter from '@/components/ContactFooter.vue'
export default {
  name: "NewsArticle",
  components: {
    ContactFooter
  },
  data() {
    return { news: news, n: null };
  },
  computed: {
    comp() {
      return defineAsyncComponent(() => import(`@/components/news/News${this.n.id}.vue`));
    },
  },
  mounted() {
    const n = this.news.find((n) => n.id == this.$route.params.id);
    this.n = n;
  },
};
</script>
<style lang=""></style>
